import { Fragment, useEffect } from "react";
import { Field, reduxForm } from "redux-form";
import { Typography } from "@material-ui/core";
import { DateTimeInput, TextInput, SelectInput } from "./FormInputs";
import { Parameter, ParameterType } from "../../api/parameters";

const requiredFields = ["timestamp", "description", "type", "value"] as const;

type FormValue = Parameter;
const validate = (value: FormValue) => {
  const errors: Partial<Record<typeof requiredFields[number], string>> = {};
  for (const field of requiredFields) {
    if (!value[field]) {
      errors[field] = "Required";
    }
  }

  return errors;
};

type FormProps = {
  title: string;
  timezone: string;
  handleSubmit?: (event: React.FormEvent<HTMLFormElement>) => void;
  error?: string;
  valid?: boolean;
  pristine?: boolean;
  submitting?: boolean;
  isValid: (valid: boolean) => void;
  isWaiting: (waiting: boolean) => void;
  types: ParameterType[];
};

const UpdateParametersForm = ({
  title,
  timezone,
  handleSubmit,
  error,
  valid,
  pristine,
  submitting,
  isValid,
  isWaiting,
  types,
}: FormProps) => {
  const options = types.reduce(
    (obj, item) => ({ ...obj, [item.id]: item.name }),
    {}
  );

  useEffect(() => {
    isValid(!pristine && !!valid && !submitting);
    isWaiting(!!submitting);
  });

  return (
    <Fragment>
      {title && (
        <Typography variant="h3" gutterBottom>
          {title}
        </Typography>
      )}
      <form noValidate onSubmit={handleSubmit}>
        <Field
          component={DateTimeInput}
          name="timestamp"
          id="parameter-form-timestamp"
          label="Timestamp"
          timezone={timezone}
        />
        <Field
          component={TextInput}
          name="description"
          id="parameter-description"
          label="Description"
        />
        <Field
          name="type"
          id="parameter-form-type"
          type="text"
          component={SelectInput}
          label="Type"
          options={options}
        />
        <Field
          name="value"
          id="parameter-form-value"
          component={TextInput}
          type="number"
          label="Value"
        />
        <Typography variant="body1" gutterBottom color="error">
          <b>{error}</b>
        </Typography>
      </form>
    </Fragment>
  );
};

export default reduxForm<FormValue, FormProps>({
  form: "UpdateParameters", // a unique identifier for this form
  validate,
})(UpdateParametersForm);
